import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { DaarcBaseScenario } from "../DaarcBaseScenario";

export class GeneralStepCollection {
    private isLooping: boolean = false;
    public loopVideo(part: BaseScenarioPart<DaarcBaseScenario>, id: string) {
		const context = this;
        context.isLooping= true;

        var play = () => {
            part.playVideoChapter(id, () => {
                if(!context.isLooping) {
                    return;
                }
    
                play();
            }, false);
        }

        play();
	}

    public stopLoop() {
        if(!this.isLooping) {
            return;
        }

        this.isLooping = false;
    }
}